/**
 * Floating widgets: Klaviyo SIGN UP stack + Zendesk launcher / proactive lift.
 */
(function () {
  var KL_CLASS = 'has-floating-kl-teaser';
  var FOLLOW_CLASS = 'is-floating-teaser-following';
  var ZENDESK_OPEN_CLASS = 'is-zendesk-chat-open';
  var PROACTIVE_LIFT_CLASS = 'float-zendesk-proactive-lift';
  var syncRaf = 0;
  var lastTeaserEl = null;
  var resizeObserver = null;
  var measureRaf = 0;
  var measureTrackRaf = 0;
  var measureTrackUntil = 0;
  var followRaf = 0;
  var followEl = null;
  var lastGiftBottom = -1;
  var watchRaf = 0;
  var watchUntil = 0;
  var stackSyncRaf = 0;
  var zendeskLauncherMo = null;
  var zendeskLauncherBound = null;
  var zendeskApplying = false;
  var zendeskMessengerBound = false;
  var zendeskDeepLinkOpened = false;
  var lastZendeskBaseline = -1;
  var zendeskPanelBottom =
    'calc(var(--float-chat-bottom) + var(--float-zendesk-launcher-h) + var(--float-stack-gap))';
  var zendeskPanelMaxH =
    'calc(100dvh - 12px - env(safe-area-inset-top, 0px) - var(--float-chat-bottom) - var(--float-zendesk-launcher-h) - var(--float-stack-gap))';

  function readCssPx(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    var n = parseFloat(v);
    return isNaN(n) ? fallback : n;
  }

  function cssVar(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  }

  function visible(el) {
    return !!(el && (el.offsetParent !== null || (el.getClientRects && el.getClientRects().length)));
  }

  function fixedAncestor(el) {
    var n = el;
    while (n && n !== document.body) {
      if (getComputedStyle(n).position === 'fixed') return n;
      n = n.parentElement;
    }
    return null;
  }

  function findKlaviyoTeaserEl() {
    var strict = document.querySelector(
      'body div.needsclick[class*="kl-teaser"], body div[class*="kl-teaser-"]'
    );
    if (strict && visible(strict)) return strict;

    var nodes = document.querySelectorAll(
      'body a[class*="kl-"], body button[class*="kl-"], body div[class*="kl-"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var c = (el.className && el.className.toString()) || '';
      if (c.indexOf('teaser') === -1 && c.indexOf('Teaser') === -1) continue;
      if (!visible(el)) continue;
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed' || fixedAncestor(el)) return fixedAncestor(el) || el;
    }

    var candidates = document.querySelectorAll('a, button, span, div, p');
    var max = Math.min(candidates.length, 500);
    for (var j = 0; j < max; j++) {
      var node = candidates[j];
      var t = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/sign\s*up/i.test(t) || t.length > 48) continue;
      var box = fixedAncestor(node);
      if (!box || !visible(box)) continue;
      var r = box.getBoundingClientRect();
      if (r.width < 40 || r.height < 32) continue;
      if (r.right < window.innerWidth * 0.42) continue;
      if (r.bottom < window.innerHeight - 140) continue;
      return box;
    }

    return null;
  }

  function findTeaserCircleEl(root) {
    if (!root) return null;
    var candidates = root.querySelectorAll('[role="button"], div, button, a, span');
    var best = null;
    var bestScore = 0;

    for (var i = 0; i < candidates.length; i++) {
      var node = candidates[i];
      var t = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/sign\s*up/i.test(t) || t.length > 24) continue;
      if (node.offsetWidth < 40 || node.offsetHeight < 40) continue;

      var cs = getComputedStyle(node);
      var w = node.offsetWidth;
      var h = node.offsetHeight;
      var score = Math.min(w, h);
      if (Math.abs(w - h) <= 12) score += 40;
      if (parseFloat(cs.borderRadius) >= Math.min(w, h) * 0.35) score += 30;
      if (cs.display === 'flex' || cs.display === 'inline-flex') score += 10;
      if (score > bestScore) {
        bestScore = score;
        best = node;
      }
    }

    return best;
  }

  function fixKlaviyoTeaserText(root) {
    var best = findTeaserCircleEl(root);
    if (!best) return;

    best.style.setProperty('display', 'flex', 'important');
    best.style.setProperty('flex-direction', 'column', 'important');
    best.style.setProperty('align-items', 'center', 'important');
    best.style.setProperty('justify-content', 'center', 'important');
    best.style.setProperty('text-align', 'center', 'important');
    best.style.setProperty('line-height', '1.05', 'important');
    best.style.setProperty('overflow', 'visible', 'important');
    best.style.setProperty('box-sizing', 'border-box', 'important');

    var textNodes = best.querySelectorAll('span, p, div');
    for (var j = 0; j < textNodes.length; j++) {
      var tn = textNodes[j];
      if (tn === best || !(tn.textContent || '').trim()) continue;
      tn.style.setProperty('line-height', '1.05', 'important');
      tn.style.setProperty('text-align', 'center', 'important');
    }
  }

  function applyGiftFollowTeaser(el) {
    var root = document.documentElement;
    var anchor = findTeaserCircleEl(el) || el;
    var r = anchor.getBoundingClientRect();
    var vh = window.innerHeight;
    var gap = readCssPx('--float-gap-signup-to-gift', 24);
    var teaserBottom = readCssPx('--float-teaser-bottom', 48);
    var giftBottom = teaserBottom;

    if (r.bottom > 0 && r.top < vh) {
      giftBottom = Math.max(teaserBottom, vh - r.top + gap);
    }

    if (Math.abs(giftBottom - lastGiftBottom) < 0.25) return;
    lastGiftBottom = giftBottom;
    root.style.setProperty('--float-gift-bottom', giftBottom + 'px');
    scheduleStackSync();
  }

  function stopTeaserFollow() {
    followEl = null;
    lastGiftBottom = -1;
    if (followRaf) {
      cancelAnimationFrame(followRaf);
      followRaf = 0;
    }
    document.documentElement.classList.remove(FOLLOW_CLASS);
  }

  function startTeaserFollow(el) {
    if (!el) return;
    followEl = el;
    document.documentElement.classList.add(FOLLOW_CLASS);
    if (followRaf) return;

    function tick() {
      if (!followEl || !visible(followEl)) {
        stopTeaserFollow();
        return;
      }
      applyGiftFollowTeaser(followEl);
      followRaf = requestAnimationFrame(tick);
    }

    followRaf = requestAnimationFrame(tick);
  }

  function stopTeaserMeasureTrack() {
    measureTrackUntil = 0;
    if (measureTrackRaf) {
      cancelAnimationFrame(measureTrackRaf);
      measureTrackRaf = 0;
    }
  }

  function startTeaserMeasureTrack(el) {
    if (measureTrackRaf) return;
    measureTrackUntil = Date.now() + 2600;

    function tick() {
      if (!el || !visible(el)) {
        stopTeaserMeasureTrack();
        return;
      }

      fixKlaviyoTeaserText(el);
      scheduleStackSync();

      if (Date.now() > measureTrackUntil) {
        stopTeaserMeasureTrack();
        return;
      }

      measureTrackRaf = requestAnimationFrame(tick);
    }

    measureTrackRaf = requestAnimationFrame(tick);
  }

  function syncTeaserLayoutRaf(el) {
    cancelAnimationFrame(measureRaf);
    measureRaf = requestAnimationFrame(function () {
      measureRaf = 0;
      fixKlaviyoTeaserText(el);
      scheduleStackSync();
    });
  }

  function resetTeaserStackVars() {
    var root = document.documentElement;
    stopTeaserMeasureTrack();
    stopTeaserFollow();
    root.classList.remove(KL_CLASS);
    root.classList.remove(FOLLOW_CLASS);
    root.style.removeProperty('--float-gift-bottom');
  }

  function releaseTeaserStackSmoothly() {
    resetTeaserStackVars();
    scheduleStackSync();
  }

  function bindResizeObserver(el) {
    if (typeof ResizeObserver === 'undefined') return;
    if (el === lastTeaserEl && resizeObserver) return;
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
    lastTeaserEl = el;
    resizeObserver = new ResizeObserver(function () {
      syncTeaserLayoutRaf(el);
    });
    resizeObserver.observe(el);
  }

  function syncKlaviyoTeaserNow() {
    var root = document.documentElement;
    var el = findKlaviyoTeaserEl();
    if (!el) {
      cancelAnimationFrame(measureRaf);
      measureRaf = 0;
      releaseTeaserStackSmoothly();
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      lastTeaserEl = null;
      scheduleStackSync();
      return;
    }
    root.classList.add(KL_CLASS);
    fixKlaviyoTeaserText(el);
    applyGiftFollowTeaser(el);
    bindResizeObserver(el);
    startTeaserMeasureTrack(el);
    startTeaserFollow(el);
    scheduleStackSync();
  }

  function syncKlaviyoTeaser() {
    if (syncRaf) return;
    syncRaf = requestAnimationFrame(function () {
      syncRaf = 0;
      syncKlaviyoTeaserNow();
    });
  }

  function startTeaserWatchBurst(duration) {
    watchUntil = Date.now() + duration;
    syncKlaviyoTeaserNow();
    if (watchRaf) return;

    function tick() {
      syncKlaviyoTeaserNow();
      if (Date.now() > watchUntil) {
        watchRaf = 0;
        return;
      }
      watchRaf = requestAnimationFrame(tick);
    }

    watchRaf = requestAnimationFrame(tick);
  }

  function scheduleStackSync() {
    cancelAnimationFrame(stackSyncRaf);
    stackSyncRaf = requestAnimationFrame(function () {
      stackSyncRaf = 0;
      bumpZendeskProactiveLift();
      bumpZendeskMessagingPanels();
    });
  }

  function stackMotionTransition() {
    if (document.documentElement.classList.contains(FOLLOW_CLASS)) return 'none';
    var dur = cssVar('--float-stack-motion-duration', '420ms');
    var ease = cssVar('--float-stack-motion-easing', 'cubic-bezier(0.22, 0.92, 0.28, 1)');
    return 'bottom ' + dur + ' ' + ease + ', max-height ' + dur + ' ' + ease;
  }

  function isZendeskLauncher(el) {
    if (!el || el.tagName !== 'IFRAME') return false;
    if (el.id === 'launcher') return true;
    var title = el.getAttribute('title') || '';
    return /launch messaging|启动消息传送窗口的按钮|消息传送窗口的按钮/i.test(title);
  }

  function isZendeskMessagingPanel(el) {
    if (!el || el.tagName !== 'IFRAME') return false;
    if (isZendeskLauncher(el)) return false;
    var title = el.getAttribute('title') || '';
    if (/消息传送窗口|Messaging window/i.test(title)) return true;
    return /Messaging/i.test(title) && (el.offsetHeight > 120 || el.offsetWidth > 200);
  }

  function readZendeskLauncherZIndex() {
    if (document.documentElement.classList.contains(ZENDESK_OPEN_CLASS)) {
      return cssVar('--float-z-chat-launcher-open', '2147483649');
    }
    return cssVar('--float-z-chat-launcher', '2147483646');
  }

  function isZendeskChatOpenHeuristic() {
    var panel = document.querySelector(
      'iframe[title="消息传送窗口"], iframe[title="Messaging window"]'
    );
    if (!panel) return false;
    var r = panel.getBoundingClientRect();
    return r.width > 200 && r.height > 200;
  }

  function setZendeskChatOpen(open) {
    document.documentElement.classList.toggle(ZENDESK_OPEN_CLASS, !!open);
    var launcher = document.getElementById('launcher');
    if (!launcher) return;
    launcher.style.setProperty('z-index', readZendeskLauncherZIndex(), 'important');
    launcher.style.setProperty('pointer-events', 'auto', 'important');
  }

  function syncZendeskChatOpenState() {
    setZendeskChatOpen(isZendeskChatOpenHeuristic());
  }

  function readBaseChatBottomPx() {
    var teaser = readCssPx('--float-teaser-bottom', 48);
    var joy = readCssPx('--float-joy-launcher-height', 56);
    var gap = readCssPx('--float-stack-gap', 24);
    return Math.round(teaser + joy + gap);
  }

  function applyZendeskBaselineOffset(force) {
    if (typeof window.zE !== 'function') return;
    var vertical = readBaseChatBottomPx();
    if (!force && Math.abs(vertical - lastZendeskBaseline) < 1) return;
    lastZendeskBaseline = vertical;

    try {
      window.zE('messenger:set', 'customization', {
        common: { hideHeader: false },
        position: {
          side: 'right',
          offset: {
            web: { horizontal: 16, vertical: vertical },
            mobile: { horizontal: 16, vertical: vertical },
          },
        },
      });
    } catch (e) {}
  }

  function isZendeskProactiveChrome(el) {
    if (!el || el.tagName !== 'IFRAME') return false;
    if (isZendeskLauncher(el) || isZendeskMessagingPanel(el)) return false;
    if (!visible(el)) return false;

    var r = el.getBoundingClientRect();
    if (r.width < 8 || r.height < 8) return false;

    var src = el.getAttribute('src') || '';
    var title = el.getAttribute('title') || '';
    if (/close|dismiss|proactive|message|messenger|消息|关闭/i.test(title)) return true;
    if (/zdassets|zendesk|messenger/i.test(src)) return true;

    var launcher = document.getElementById('launcher');
    if (!launcher) return false;
    var lr = launcher.getBoundingClientRect();
    if (!lr.width || !lr.height) return false;

    var stackRight = lr.right;
    var stackLeft = stackRight - 380;
    var inStackColumn = r.right >= stackLeft && r.right <= stackRight + 20;
    var aboveLauncher = r.bottom >= lr.top - 420 && r.bottom <= lr.bottom + 56;
    return inStackColumn && aboveLauncher;
  }

  function startProactiveLiftBurst(duration) {
    var until = Date.now() + (duration || 2400);
    function tick() {
      bumpZendeskProactiveLift();
      if (Date.now() < until) requestAnimationFrame(tick);
    }
    tick();
  }

  function bumpZendeskProactiveLift() {
    var chatOpen =
      document.documentElement.classList.contains(ZENDESK_OPEN_CLASS) || isZendeskChatOpenHeuristic();

    document.querySelectorAll('iframe').forEach(function (el) {
      var tagged = el.classList.contains(PROACTIVE_LIFT_CLASS);
      if (!isZendeskProactiveChrome(el) || chatOpen) {
        if (tagged) el.classList.remove(PROACTIVE_LIFT_CLASS);
        return;
      }
      el.classList.add(PROACTIVE_LIFT_CLASS);
    });
  }

  function bindZendeskMessengerEvents() {
    if (zendeskMessengerBound || typeof window.zE !== 'function') return;

    window.zE(function () {
      zendeskMessengerBound = true;
      try {
        applyZendeskBaselineOffset(true);
        window.zE('messenger:on', 'open', function () {
          setZendeskChatOpen(true);
          scheduleStackSync();
        });
        window.zE('messenger:on', 'close', function () {
          setZendeskChatOpen(false);
          initZendesk();
        });
        window.zE('messenger:on', 'proactiveMessageDisplayed', function () {
          applyZendeskBaselineOffset(true);
          startProactiveLiftBurst(2600);
        });
      } catch (e) {}
    });
  }

  function openZendeskDeepLink() {
    if (zendeskDeepLinkOpened || typeof window.zE !== 'function') return;
    if (new URLSearchParams(window.location.search).get('openZendesk') !== '1') return;

    zendeskDeepLinkOpened = true;
    try {
      window.zE('messenger', 'open');
    } catch (e) {
      zendeskDeepLinkOpened = false;
    }
  }

  function applyZendeskLauncherVisuals(launcher) {
    if (zendeskApplying || !launcher) return;
    zendeskApplying = true;

    var renderSize = readCssPx('--float-zendesk-launcher-render-h', 64);
    var visualSize = readCssPx('--float-zendesk-launcher-h', 48);
    var scale = visualSize / renderSize;
    var renderPx = renderSize + 'px';

    launcher.style.removeProperty('inset');
    launcher.style.removeProperty('top');
    launcher.style.removeProperty('left');
    launcher.style.removeProperty('right');
    launcher.style.removeProperty('transition');
    launcher.style.setProperty('width', renderPx, 'important');
    launcher.style.setProperty('height', renderPx, 'important');
    launcher.style.setProperty('min-width', renderPx, 'important');
    launcher.style.setProperty('min-height', renderPx, 'important');
    launcher.style.setProperty('max-width', renderPx, 'important');
    launcher.style.setProperty('max-height', renderPx, 'important');
    launcher.style.setProperty('border-radius', '50%', 'important');
    launcher.style.setProperty('overflow', 'hidden', 'important');
    launcher.style.setProperty('border', '0', 'important');
    launcher.style.setProperty('box-sizing', 'border-box', 'important');
    launcher.style.setProperty('transform', 'scale(' + scale + ')', 'important');
    launcher.style.setProperty('transform-origin', 'bottom right', 'important');
    launcher.style.setProperty('z-index', readZendeskLauncherZIndex(), 'important');
    launcher.style.setProperty('pointer-events', 'auto', 'important');

    zendeskApplying = false;
  }

  function attachZendeskLauncherObserver(launcher) {
    if (!launcher || launcher === zendeskLauncherBound) return;
    if (zendeskLauncherMo) {
      zendeskLauncherMo.disconnect();
      zendeskLauncherMo = null;
    }
    zendeskLauncherBound = launcher;
    zendeskLauncherMo = new MutationObserver(function () {
      if (zendeskApplying) return;
      applyZendeskLauncherVisuals(launcher);
    });
    zendeskLauncherMo.observe(launcher, { attributes: true, attributeFilter: ['style'] });
  }

  function initZendesk() {
    bindZendeskMessengerEvents();
    applyZendeskBaselineOffset(false);
    openZendeskDeepLink();

    var launcher = document.getElementById('launcher');
    if (launcher) {
      applyZendeskLauncherVisuals(launcher);
      attachZendeskLauncherObserver(launcher);
    }

    syncZendeskChatOpenState();
    scheduleStackSync();
  }

  function bumpZendeskMessagingPanels() {
    var isDesktop =
      typeof window.matchMedia === 'function'
        ? window.matchMedia('(min-width: 769px)').matches
        : window.innerWidth > 768;
    var motion = stackMotionTransition();
    var panelZ = cssVar('--float-z-chat-panel', '2147483648');
    var chatOpen =
      document.documentElement.classList.contains(ZENDESK_OPEN_CLASS) || isZendeskChatOpenHeuristic();

    document.querySelectorAll('iframe').forEach(function (el) {
      if (!isZendeskMessagingPanel(el)) return;
      el.style.setProperty('z-index', panelZ, 'important');
      if (!isDesktop || !chatOpen) {
        syncZendeskChatOpenState();
        return;
      }

      el.style.removeProperty('inset');
      el.style.setProperty('right', '16px', 'important');
      el.style.setProperty('left', 'auto', 'important');
      el.style.setProperty('bottom', zendeskPanelBottom, 'important');
      el.style.setProperty('top', 'auto', 'important');
      el.style.setProperty('max-height', zendeskPanelMaxH, 'important');
      if (motion === 'none') {
        el.style.setProperty('transition', 'none', 'important');
      } else {
        el.style.removeProperty('transition');
      }
    });

    var webWidget = document.getElementById('webWidget');
    if (!webWidget) return;

    webWidget.style.setProperty('z-index', chatOpen ? panelZ : readZendeskLauncherZIndex(), 'important');
    if (!isDesktop || !chatOpen) return;

    webWidget.style.setProperty('right', '16px', 'important');
    webWidget.style.setProperty('left', 'auto', 'important');
    webWidget.style.setProperty('bottom', zendeskPanelBottom, 'important');
    webWidget.style.setProperty('top', 'auto', 'important');
    webWidget.style.setProperty('max-height', zendeskPanelMaxH, 'important');
    if (motion === 'none') {
      webWidget.style.setProperty('transition', 'none', 'important');
    } else {
      webWidget.style.removeProperty('transition');
    }
  }

  if (typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(syncKlaviyoTeaser);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncKlaviyoTeaser);
  } else {
    syncKlaviyoTeaser();
  }

  initZendesk();

  if (typeof MutationObserver !== 'undefined' && !document.getElementById('launcher')) {
    var zendeskLauncherWait = new MutationObserver(function () {
      if (document.getElementById('launcher')) {
        initZendesk();
        zendeskLauncherWait.disconnect();
      }
    });
    zendeskLauncherWait.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      zendeskLauncherWait.disconnect();
    }, 90000);
  }

  var pollUntil = Date.now() + 90000;
  var poll = setInterval(function () {
    syncKlaviyoTeaser();
    initZendesk();
    if (Date.now() > pollUntil) clearInterval(poll);
  }, 800);

  var resizeT;
  window.addEventListener(
    'resize',
    function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        syncKlaviyoTeaser();
        initZendesk();
      }, 100);
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerdown',
    function () {
      startTeaserWatchBurst(2600);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      startTeaserWatchBurst(2600);
      if (e.target.closest('#launcher, iframe#launcher')) {
        requestAnimationFrame(initZendesk);
      }
      if (e.target.closest('#Avada-Joy_FloatingButton, .Avada-Joy_ButtonWidget, .Avada-Preview_Popup')) {
        scheduleStackSync();
      }
    },
    true
  );
})();
